import { CarrierCodeType } from '@/features/shipment/types';

export const merchantRegCarriers: (keyof typeof CarrierCodeType)[] = ['Canadapost'];
export const externalAuthenticationNeeded: (keyof typeof CarrierCodeType)[] = ['UPS'];
export const fedexRegistrationCarriers: (keyof typeof CarrierCodeType)[] = ['FedEx'];

export function isRegisteredThroughMerchant(
  carrier: keyof typeof CarrierCodeType,
): boolean {
  return merchantRegCarriers.includes(carrier);
}

export function isRequiredExternalAuthentication(
  carrier: keyof typeof CarrierCodeType,
) {
  return externalAuthenticationNeeded.includes(carrier);
}

export function isFedexRegistration(
  carrier: keyof typeof CarrierCodeType,
): boolean {
  return fedexRegistrationCarriers.includes(carrier);
}
